// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file shop_config/types/v1/common.proto (package shop_config.types.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Text } from "../../../types/v1/text_pb.js";

/**
 * @generated from enum shop_config.types.v1.ShopLanguage
 */
export const ShopLanguage = /*@__PURE__*/ proto3.makeEnum(
  "shop_config.types.v1.ShopLanguage",
  [
    {no: 0, name: "SHOP_LANGUAGE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SHOP_LANGUAGE_BG", localName: "BG"},
    {no: 2, name: "SHOP_LANGUAGE_DA", localName: "DA"},
    {no: 3, name: "SHOP_LANGUAGE_DE", localName: "DE"},
    {no: 4, name: "SHOP_LANGUAGE_EN", localName: "EN"},
    {no: 5, name: "SHOP_LANGUAGE_ET", localName: "ET"},
    {no: 6, name: "SHOP_LANGUAGE_FI", localName: "FI"},
    {no: 7, name: "SHOP_LANGUAGE_FR", localName: "FR"},
    {no: 8, name: "SHOP_LANGUAGE_EL", localName: "EL"},
    {no: 9, name: "SHOP_LANGUAGE_IE", localName: "IE"},
    {no: 10, name: "SHOP_LANGUAGE_IT", localName: "IT"},
    {no: 11, name: "SHOP_LANGUAGE_HR", localName: "HR"},
    {no: 12, name: "SHOP_LANGUAGE_LV", localName: "LV"},
    {no: 13, name: "SHOP_LANGUAGE_LT", localName: "LT"},
    {no: 14, name: "SHOP_LANGUAGE_MT", localName: "MT"},
    {no: 15, name: "SHOP_LANGUAGE_NL", localName: "NL"},
    {no: 16, name: "SHOP_LANGUAGE_PL", localName: "PL"},
    {no: 17, name: "SHOP_LANGUAGE_PT", localName: "PT"},
    {no: 18, name: "SHOP_LANGUAGE_RO", localName: "RO"},
    {no: 19, name: "SHOP_LANGUAGE_SE", localName: "SE"},
    {no: 20, name: "SHOP_LANGUAGE_SK", localName: "SK"},
    {no: 21, name: "SHOP_LANGUAGE_SI", localName: "SI"},
    {no: 22, name: "SHOP_LANGUAGE_ES", localName: "ES"},
    {no: 23, name: "SHOP_LANGUAGE_CS", localName: "CS"},
    {no: 24, name: "SHOP_LANGUAGE_TR", localName: "TR"},
    {no: 25, name: "SHOP_LANGUAGE_HU", localName: "HU"},
  ],
);

/**
 * @generated from message shop_config.types.v1.SaveCommonConfigurationRequest
 */
export const SaveCommonConfigurationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.SaveCommonConfigurationRequest",
  () => [
    { no: 1, name: "common_configuration", kind: "message", T: CommonConfiguration },
  ],
);

/**
 * @generated from message shop_config.types.v1.SaveCommonConfigurationResponse
 */
export const SaveCommonConfigurationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.SaveCommonConfigurationResponse",
  () => [
    { no: 1, name: "common_configuration", kind: "message", T: CommonConfiguration },
  ],
);

/**
 * @generated from message shop_config.types.v1.CommonConfiguration
 */
export const CommonConfiguration = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.CommonConfiguration",
  () => [
    { no: 1, name: "logo_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "title", kind: "message", T: Text, opt: true },
    { no: 3, name: "sub_title", kind: "message", T: Text, opt: true },
    { no: 4, name: "default_language", kind: "enum", T: proto3.getEnumType(ShopLanguage), opt: true },
    { no: 5, name: "languages", kind: "enum", T: proto3.getEnumType(ShopLanguage), repeated: true },
    { no: 6, name: "show_location_filter", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "show_date_filter", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 8, name: "show_slogan", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 9, name: "slogan_title", kind: "message", T: Text, opt: true },
    { no: 10, name: "slogan_sub_title", kind: "message", T: Text, opt: true },
    { no: 11, name: "slogan_background_color", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "slogan_text_color", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "show_ticket_availability", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 14, name: "show_event_month_badge", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message shop_config.types.v1.GetCommonConfigurationRequest
 */
export const GetCommonConfigurationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.GetCommonConfigurationRequest",
  [],
);

/**
 * @generated from message shop_config.types.v1.GetCommonConfigurationResponse
 */
export const GetCommonConfigurationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.GetCommonConfigurationResponse",
  () => [
    { no: 1, name: "common_configuration", kind: "message", T: CommonConfiguration },
  ],
);

/**
 * @generated from message shop_config.types.v1.ListAllShopsRequest
 */
export const ListAllShopsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.ListAllShopsRequest",
  [],
);

/**
 * @generated from message shop_config.types.v1.ListAllShopsResponse
 */
export const ListAllShopsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.ListAllShopsResponse",
  () => [
    { no: 1, name: "shops", kind: "message", T: ListAllShopsResponse_Shop, repeated: true },
  ],
);

/**
 * @generated from message shop_config.types.v1.ListAllShopsResponse.Shop
 */
export const ListAllShopsResponse_Shop = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.ListAllShopsResponse.Shop",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "logo_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "title", kind: "message", T: Text, opt: true },
    { no: 4, name: "slogan_title", kind: "message", T: Text, opt: true },
  ],
  {localName: "ListAllShopsResponse_Shop"},
);

